import { MenuItem, Typography } from '@mui/material';
import type { AvailableModel } from '../../../types/backend';

// A listed model the account cannot call is shown disabled with its reason (PS-UC-08 2a,
// PS-UC-17 2a). Returned as MenuItem elements, not a component, because a select reads its
// options' values from its direct children.
export function modelOptions(models: AvailableModel[]) {
  return models.map((model) => (
    <MenuItem key={model.model_id} value={model.model_id} disabled={!model.available}>
      {model.label}
      {!model.available && model.reason && (
        <Typography component="span" variant="caption" color="warning.main" sx={{ ml: 1 }}>
          {model.reason}
        </Typography>
      )}
    </MenuItem>
  ));
}
